import type { ReactElement } from 'react';

import { REGEXP_PLACEHOLDER } from './constants';

export function interpolatePlaceholders(
  str: string,
  locale: string,
  placeholders: Partial<Record<string, string | number>>
): string;
export function interpolatePlaceholders(
  str: string,
  locale: string,
  placeholders: Partial<Record<string, string | number | ReactElement>>
): string | ReactElement[];
export function interpolatePlaceholders(
  str: string,
  locale: string,
  placeholders: Partial<Record<string, string | number | ReactElement>>
): string | (string | ReactElement)[] {
  const parts = str.split(REGEXP_PLACEHOLDER);
  let hasElement = false;
  const segments: (string | ReactElement)[] = [];

  for (let i = 0; i < parts.length; i++) {
    const isNonMatchingPart = i % 2 === 0;

    if (isNonMatchingPart) {
      if (parts[i]) {
        segments.push(parts[i]);
      }
    } else {
      const value = placeholders[parts[i]];

      if (value === undefined) {
        segments.push(`{${parts[i]}}`);
      } else if (typeof value === 'number') {
        segments.push(value.toLocaleString(locale));
      } else if (typeof value === 'string') {
        if (value) {
          segments.push(value);
        }
      } else {
        hasElement = true;
        segments.push(value);
      }
    }
  }

  return hasElement ? segments : (segments as string[]).join('');
}
